import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/** Old deep links `/interview-prep/:track/:topic` → same-page book reader. */
const InterviewPrepTopicRedirect = () => {
  const { trackId, topicId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (trackId && topicId) {
      navigate(`/interview-prep/${trackId}?topic=${encodeURIComponent(topicId)}`, {
        replace: true,
      });
    } else if (trackId) {
      navigate(`/interview-prep/${trackId}`, { replace: true });
    } else {
      navigate('/interview-prep', { replace: true });
    }
  }, [trackId, topicId, navigate]);

  return null;
};

export default InterviewPrepTopicRedirect;
